<template>
    <v-card class="pa-4 box_shadow_class mt-0">
      <div>
        <div>
          <span>
            <HeaderComponent :headerTitle="headerText" />
          </span>
        </div>
        <v-container class="ma-0 pa-0" fluid grid-list-lg>
          <v-layout class="ma-0 pa-0" row wrap>
            
              <v-row class="m-0">
                <!-- claim raise -->
                <v-col xs3 cols="3" sm="3" md="3" @click="resetActiveTab">
                  <router-link :to="{ name: 'claimRaise' }">
                    <v-card class="pa-4 box_shadow_class">
                      <div align="center" justify="center">
                        <img class="mt-3" src="@/assets/images/icons/inward-icons/claim-request.png" width="108" height="108" />
                      </div>
                      <div class="mt-3 text-color" align="center" justify="center">
                        Claim Raise Bucket  
                      </div>
                    </v-card>
                  </router-link>
                </v-col>
                <!-- item tracking -->
                <v-col xs3 cols="3" sm="3" md="3">
                  <router-link :to="{ name: 'inwardTracking' }">
                    <v-card class="pa-4 box_shadow_class">
                      <div align="center" justify="center">
                        <img class="mt-3" src="@/assets/images/icons/inward-icons/inward-tracking.png" width="108" height="108" />
                      </div>
                      <div class="mt-3 text-color" align="center" justify="center">
                        Inward Tracking  
                      </div>
                    </v-card>
                  </router-link>
                </v-col>
                <!-- Excess Item details -->
                <v-col xs3 cols="3" sm="3" md="3">
                  <router-link :to="{ name: 'excessItemDetails' }">
                    <v-card class="pa-4 box_shadow_class">
                      <div align="center" justify="center">
                        <img class="mt-3" src="@/assets/images/icons/inward-icons/excess-item-details.png" width="108" height="108" />
                      </div>
                      <div class="mt-3 text-color" align="center" justify="center">
                        Excess Item Details 
                      </div>
                    </v-card>
                  </router-link>
                </v-col>
                <!-- item tracking end -->
                <!-- pending return -->
                
                <!-- pending return ends -->
                
              </v-row>
          </v-layout>
        </v-container>
      </div>
    </v-card>
  </template>
  
  <script>
    import HeaderComponent from "./../../../commoncomponents/HeaderComponent.vue";
    import { mapState } from "vuex"
    export default {
      data() {
        return {
          headerText: "Inwarding",
        };
      },
  
      components: {
        HeaderComponent,
      },
  
      computed: mapState(["currentUser", "signedIn"]),
  
      created() { },
  
      methods: {
        loadData(tab) {
          this.active_tab = tab;
        },
  
        navigateTarget(routerName) {
          this.$router.push({ name: routerName });
        },
        resetActiveTab(){
          this.$store.commit('setActiveTab',{
            'active_tab' : ''
          })
        }
      },
    };
  </script>
  